import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { Router } from '@angular/router';
import { ExpertEventNotificationRecord } from '@libs/shared/api';
import { ExpertEventNotificationWrapperComponent } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification-wrapper.component';
import { injectExpertEventNotificationService } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification.service';
import { ExpertMemberTitlePipe } from '@sprint-expert/app/utils/pipe/expert-member-title.pipe';

@Component({
  selector: 'app-expert-member-joined-notification',
  standalone: true,
  imports: [
    CommonModule,
    ExpertEventNotificationWrapperComponent,
    ExpertMemberTitlePipe,
  ],
  template: `
    <app-expert-event-notification-wrapper
      class="cursor-pointer"
      (click)="onClick()"
      [notification]="notification"
      title="회원 연동 완료">
      <div class="text-secondary line-clamp-2">
        {{ notification.expertMember | expertMemberTitle }}님이 회원으로
        연동되었습니다.
      </div>
    </app-expert-event-notification-wrapper>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertMemberJoinedNotificationComponent {
  readonly vm = injectExpertEventNotificationService();
  readonly router = inject(Router);

  @Input({ required: true })
  notification: ExpertEventNotificationRecord;

  onClick() {
    this.vm.readExpertEventNotification(this.notification);
    this.router.navigate(
      [
        'expert-workspace',
        this.vm.currentExpertWorkspace$$().id,
        'settings',
        'account',
      ],
      {
        onSameUrlNavigation: 'reload',
      }
    );
  }
}
